define(['jquery'],
	function ($) {

		function inputValidator(patterns) {
			this.patterns = patterns || {};
		}

		inputValidator.prototype = {
			validate: function (type, data) {
				if (typeof type != 'string') {
					throw new Error('Missing type for validation');
				}
				if (typeof data != 'string') {
					throw new Error('Missing data for validation');
				}
				if (typeof this.patterns[type] != 'string') {
					throw new Error('Missing regex pattern for validating type "' + type + '"');
				}
				return new RegExp(this.patterns[type]).test(data);
			},

			patternExists: function (type) {
				return !!this.patterns[type];
			},

			extendPatterns: function (extend_patterns) {
				if (typeof extend_patterns == 'object') {
					$.extend(this.patterns, extend_patterns);
				}
			},

			addPattern: function (type, pattern) {
				this.patterns[type] = pattern;
			},

			isEmpty: function (input) {
				var empty = false;
				switch (typeof input) {
					case 'undefined':
						empty = true;
						break;
					case 'object':
						if (input == null) {
							empty = true;
						} else if (Array.isArray(input)) {
							empty = (input.length <= 0);
						} else if (JSON.stringify(input) == "{}") {
							empty = true;
						}
						break;
					case 'string':
						empty = input.length == 0;
						break;
					default:
						empty = false;
				}
				return empty;
			}
		};

		return inputValidator;
	});